const abroadState = {
  visible: false,
  loaded: false,
}

export const abroad = (state = abroadState, action: any) => {
  switch (action.type) {
    case 'SET_ABROAD_VISIBLE':
      return {
        visible: action.visible,
        loaded: true,
      }
    case 'RESET_ABROAD_VISIBLE':
      return {
        visible: false,
        loaded: false,
      }
    default:
      return state
  }
}
